/* BrighterWhite theme interactions (vanilla JS, no dependencies) */
(function () {
  'use strict';
  var BW = (window.BW = window.BW || {});
  BW.routes = BW.routes || { cartAdd: '/cart/add.js', cart: '/cart', cartJs: '/cart.js' };

  BW.formatMoney = function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var sf = BW._sampleFmt();
    if (sf) {
      var neg = cents < 0, n = Math.abs(cents);
      var parts = (n / 100).toFixed(sf.d).split('.');
      var whole = sf.ts ? parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + sf.ts) : parts[0];
      return (neg ? '-' : '') + sf.pre + whole + (sf.d ? sf.ds + parts[1] : '') + sf.post;
    }
    var format = BW.moneyFormat || '${{amount}}';
    function fmt(n, d, ts, ds) {
      d = d === undefined ? 2 : d; ts = ts || ','; ds = ds || '.';
      var num = (n / 100).toFixed(d).split('.');
      var whole = num[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts);
      return whole + (num[1] ? ds + num[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  /* Store credit: pct of a price in cents, rounded to whole currency units; formatted without trailing zeros ("$30"). */
  BW.earnCents = function (cents, pct) { return Math.round((parseInt(cents, 10) || 0) * (pct || 0) / 10000) * 100; };
  BW.formatWhole = function (cents) { return BW.formatMoney(cents).replace(/[.,]00(?![\d])/, ''); };
  /* Earn-credit info popover: tap/click toggles, outside tap or Escape closes. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bw-earn-info]');
    Array.prototype.forEach.call(document.querySelectorAll('[data-bw-earn-info][aria-expanded="true"]'), function (b) {
      if (b === btn) return;
      b.setAttribute('aria-expanded', 'false');
      var t = document.getElementById(b.getAttribute('aria-controls')); if (t) t.hidden = true;
    });
    if (!btn) return;
    e.preventDefault();
    var tip = document.getElementById(btn.getAttribute('aria-controls')); if (!tip) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false'); tip.hidden = !open;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-bw-earn-info][aria-expanded="true"]'), function (b) {
      b.setAttribute('aria-expanded', 'false');
      var t = document.getElementById(b.getAttribute('aria-controls')); if (t) t.hidden = true;
    });
  });

  /* Presentment-currency money format, derived from Liquid's {{ 123456 | money }} sample
     ("$1,234.56", "€1.234,56", "1 234,56 kr", "¥1,235") so JS prices match Liquid in every market. */
  BW._sampleFmt = function () {
    if (BW._sf !== undefined) return BW._sf;
    var s = BW.moneySample, m = s && s.match(/1([^\d]?)234([^\d])56|1([^\d]?)235/);
    if (!m) return (BW._sf = null);
    var pre = s.slice(0, m.index), post = s.slice(m.index + m[0].length);
    BW._sf = m[2] !== undefined ? { pre: pre, post: post, d: 2, ts: m[1] || '', ds: m[2] } : { pre: pre, post: post, d: 0, ts: m[3] || '', ds: '' };
    return BW._sf;
  };
  /* Free-shipping threshold in presentment cents. Listed currencies (Theme settings, e.g. USD:79, AUD:119)
     come from Liquid; anything else converts the store threshold with Shopify's exchange rate. */
  BW.fxRate = function () { var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return r > 0 ? r : 1; };
  BW.shipGoal = function () {
    var g = BW.shipGoalCents || 7900;
    return BW.shipFx ? Math.round(g * BW.fxRate()) : g;
  };
  BW.shipLabel = function () { return BW.formatMoney(BW.shipGoal()).replace(/[.,]00(?!\d)/, '') + ' ' + (BW.currency || ''); };
  /* Server-rendered free-shipping bars (cart drawer, /cart) carry data-bw-ship-fx when the currency
     isn't listed; recompute them client-side with the converted threshold. */
  BW.fixShipBars = function (root) {
    if (!BW.shipFx) return;
    $$('[data-bw-ship-fx][data-total]', root || document).forEach(function (el) {
      var goal = BW.shipGoal(), total = parseInt(el.getAttribute('data-total'), 10) || 0;
      if (el.getAttribute('data-bw-ship-applied') === goal + ':' + total) return;
      el.setAttribute('data-bw-ship-applied', goal + ':' + total);
      var left = goal - total, done = left <= 0, pct = done ? 100 : Math.floor(total * 100 / goal);
      el.classList.toggle('is-done', done);
      var fill = $('[data-bw-ship-fill]', el); if (fill) fill.style.width = pct + '%';
      var bar = $('[role="progressbar"]', el); if (bar) bar.setAttribute('aria-valuenow', pct);
      var msg = $('[data-bw-ship-msg]', el);
      if (msg) {
        var tpl = done ? el.getAttribute('data-tpl-done') : el.getAttribute('data-tpl-progress');
        msg.innerHTML = (done ? (el.getAttribute('data-icon-done') || '') : '') + escapeHtml(tpl || '').replace('[amount]', '<strong>' + BW.formatMoney(left) + (el.hasAttribute('data-show-code') ? ' ' + escapeHtml(BW.currency || '') : '') + '</strong>');
      }
      $$('[data-bw-ship-label]', el).forEach(function (l) { l.textContent = BW.shipLabel(); });
    });
  };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  BW.toast = function (msg, showCartLink) {
    var t = $('.bw-toast');
    if (!t) { t = document.createElement('div'); t.className = 'bw-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '';
    t.appendChild(document.createTextNode(msg));
    if (showCartLink) { var a = document.createElement('a'); a.href = BW.routes.cart; a.textContent = 'View cart'; t.appendChild(a); }
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 3800);
  };

  BW.refreshCart = function () {
    return fetch(BW.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        BW.cart = cart;
        $$('.bw-cart-count').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
        document.dispatchEvent(new CustomEvent('bw:cart-updated', { detail: cart }));
        return cart;
      })
      .catch(function () { return null; });
  };

  BW.addToCart = function (items) {
    return fetch(BW.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  };


  /* ---------- Slide-out cart drawer (sections/bw-cart-drawer.liquid) ---------- */
  var CD = { el: null, lastFocus: null, timerInt: null, recsCache: {} };
  BW.cartDrawer = CD;
  var TIMER_KEY = 'bwCartTimerStart';
  function cdRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  CD.enabled = function () { CD.el = CD.el || $('[data-bw-cart-drawer]'); return !!(CD.el && CD.el.getAttribute('data-enabled') === 'true'); };
  CD.focusables = function () { return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', $('.bw-cd__panel', CD.el)).filter(function (n) { return n.offsetParent !== null; }); };
  CD.open = function () {
    if (!CD.enabled()) return false;
    if (!CD.el.classList.contains('is-open')) CD.lastFocus = document.activeElement;
    CD.el.removeAttribute('inert'); CD.el.setAttribute('aria-hidden', 'false');
    CD.el.classList.add('is-open'); document.documentElement.classList.add('bw-cd-lock');
    $$('.bw-header__cart').forEach(function (a) { a.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var c = $('.bw-cd__close', CD.el); if (c) c.focus(); }, 60);
    return true;
  };
  CD.close = function () {
    if (!CD.el || !CD.el.classList.contains('is-open')) return;
    CD.el.classList.remove('is-open'); CD.el.setAttribute('aria-hidden', 'true'); CD.el.setAttribute('inert', '');
    document.documentElement.classList.remove('bw-cd-lock');
    $$('.bw-header__cart').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    if (CD.lastFocus && CD.lastFocus.focus) CD.lastFocus.focus();
  };
  CD.announce = function (msg) { var l = $('[data-bw-cart-live]', CD.el); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 50); } };
  CD.swap = function (html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nb = doc.querySelector('[data-bw-cart-body]'), ob = $('[data-bw-cart-body]', CD.el);
    if (!nb || !ob) return;
    var hadFocus = ob.contains(document.activeElement) ? (document.activeElement.getAttribute('aria-label') || '') : null;
    ob.replaceWith(nb);
    CD.bindBody();
    if (hadFocus !== null) {
      var t = $$('button', nb).filter(function (b) { return b.getAttribute('aria-label') === hadFocus; })[0] || $('.bw-cd__close', nb);
      if (t) t.focus();
    }
  };
  CD.refresh = function () {
    if (!CD.enabled()) return Promise.resolve();
    /* no Accept: application/json here - with it Shopify leaves out the express checkout (wallet) buttons */
    return fetch(cdRoot() + '?sections=bw-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (d) { CD.swap(d['bw-cart-drawer']); })
      .catch(function () {});
  };
  /* After any add to cart: auto-bump free 2nd Value Pack if needed, then refresh counts + drawer and open it. */
  BW.afterAdd = function (label) {
    if (!CD.enabled()) return false;
    if (!localStorage.getItem(TIMER_KEY)) { try { localStorage.setItem(TIMER_KEY, String(Date.now())); } catch (e) {} }
    var open = function () {
      BW.refreshCart();
      CD.refresh().then(function () { CD.open(); CD.announce((label || 'Item') + ' added to cart'); });
    };
    if (BW.bogoEnsure) BW.bogoEnsure({ initialAdd: true }).then(open, open); else open();
    return true;
  };
  CD.change = function (key, qty, title) {
    var body = $('[data-bw-cart-body]', CD.el); if (body) body.classList.add('is-busy');
    return fetch(cdRoot() + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: ['bw-cart-drawer'] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not update cart'); return d; }); })
      .then(function (cart) {
        if (cart.sections) CD.swap(cart.sections['bw-cart-drawer']); else CD.refresh();
        /* change.js section renders omit the wallet buttons; re-fetch the drawer to bring them back */
        var ex = $('.bw-cd__express', CD.el); if (ex && !ex.children.length) CD.refresh();
        BW.refreshCart();
        CD.announce(qty <= 0 ? (title || 'Item') + ' removed' : 'Quantity updated to ' + qty);
      })
      .catch(function (err) { if (body) body.classList.remove('is-busy'); BW.toast(err.message); });
  };
  CD.tick = function () {
    var t = $('[data-bw-cart-timer]', CD.el); clearInterval(CD.timerInt);
    if (!t) return;
    var start = parseInt(localStorage.getItem(TIMER_KEY), 10);
    if (!start) { start = Date.now(); try { localStorage.setItem(TIMER_KEY, String(start)); } catch (e) {} }
    var total = (parseInt(t.getAttribute('data-minutes'), 10) || 10) * 60;
    var out = $('[data-bw-cart-timer-time]', t);
    function draw() {
      var left = total - Math.floor((Date.now() - start) / 1000);
      if (left <= 0) {
        clearInterval(CD.timerInt); t.classList.add('is-done');
        $('[data-bw-cart-timer-text]', t).textContent = t.getAttribute('data-done') || 'Your cart is still saved - check out soon';
        return;
      }
      var m = Math.floor(left / 60), sec = left % 60;
      if (out) out.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    draw(); CD.timerInt = setInterval(draw, 1000);
  };
  CD.recs = function () {
    var box = $('[data-bw-cart-recs]', CD.el); if (!box) return;
    var list = $('[data-bw-cart-recs-list]', box);
    var inCart = (box.getAttribute('data-in-cart') || '').split(',');
    var hasKit = box.hasAttribute('data-has-kit');
    var hidden = (box.getAttribute('data-hidden-handles') || '').split(',');
    var bogo = box.hasAttribute('data-bogo');
    var bb = $('[data-bw-cart-bogo-add]', box);
    if (bb) bb.addEventListener('click', function () {
      bb.disabled = true; bb.classList.add('is-loading');
      BW.addToCart([{ id: parseInt(bb.getAttribute('data-bw-cart-bogo-add'), 10), quantity: 1 }])
        .then(function () { BW.afterAdd(bb.getAttribute('data-title')); })
        .catch(function (err) { bb.disabled = false; bb.classList.remove('is-loading'); BW.toast(err.message); });
    });
    var fb = []; try { fb = JSON.parse($('[data-bw-cart-recs-fallback]', box).textContent); } catch (e) {}
    function norm(p) {
      var v = p.variants ? (p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]) : null;
      var img = p.image || p.featured_image || '';
      if (img && typeof img === 'object') img = img.src || img.url || '';
      if (!CD.photoMap) { try { CD.photoMap = JSON.parse(($('[data-bw-photo-map]') || {}).textContent || '{}'); } catch (e) { CD.photoMap = {}; } }
      var ph = p.handle || ((p.url || '').match(/\/products\/([^/?#]+)/) || [])[1];
      if (ph && CD.photoMap[ph]) img = CD.photoMap[ph];
      var isGel = /gel/.test(ph || '') && !/desensiti/.test(ph || '');
      /* gel packs: compare-at is just singles x N, so no strike-through in the cart */
      return { id: p.id, handle: ph || '', variant_id: p.variant_id || (v && v.id), title: p.title, url: p.url, image: img, price: v ? v.price : p.price, compare_at_price: isGel ? 0 : (v ? (v.compare_at_price || 0) : (p.compare_at_price || 0)), available: v ? v.available : p.available };
    }
    function draw(items) {
      var seen = {};
      items = items.map(norm).filter(function (p) {
        if (!p.variant_id || !p.available || inCart.indexOf(String(p.id)) > -1 || seen[p.id]) return false;
        if (p.handle && hidden.indexOf(p.handle) > -1) return false; /* upsell-only products */
        if (hasKit && /(^|-)kit(-|$)/.test(p.handle)) return false; /* never suggest a second kit */
        seen[p.id] = 1; return true;
      }).slice(0, bogo ? 1 : 2); /* the 2nd-Value-Pack card takes one of the two slots */
      if (!items.length) { list.innerHTML = ''; box.hidden = !bogo; return; }
      list.innerHTML = items.map(function (p) {
        var img = p.image ? String(p.image).replace(/^\/\//, 'https://') : '';
        if (img && img.indexOf('width=') < 0) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        return '<li class="bw-cd__rec">' +
          '<a href="' + escapeHtml(p.url) + '" class="bw-cd__rec-img" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
          '<div class="bw-cd__rec-info"><a href="' + escapeHtml(p.url) + '" class="bw-cd__rec-name">' + escapeHtml(p.title) + '</a>' +
          '<p class="bw-cd__rec-price">' + (p.compare_at_price > p.price ? '<s>' + BW.formatMoney(p.compare_at_price) + '</s> ' : '') + '<strong>' + BW.formatMoney(p.price) + '</strong></p></div>' +
          '<button type="button" class="bw-cd__rec-add" data-bw-cart-rec-add="' + p.variant_id + '" data-title="' + escapeHtml(p.title) + '" aria-label="Add ' + escapeHtml(p.title) + ' to cart">+ Add</button></li>';
      }).join('');
      box.hidden = false;
      $$('[data-bw-cart-rec-add]', list).forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.classList.add('is-loading');
          BW.addToCart([{ id: parseInt(b.getAttribute('data-bw-cart-rec-add'), 10), quantity: 1 }])
            .then(function () { BW.afterAdd(b.getAttribute('data-title')); })
            .catch(function (err) { b.disabled = false; b.classList.remove('is-loading'); BW.toast(err.message); });
        });
      });
    }
    var pid = box.getAttribute('data-product-id');
    if (!pid) { draw(fb); return; }
    /* with a kit in the cart the curated refill/accessory list goes first */
    function merge(api) { return hasKit ? fb.concat(api) : api.concat(fb); }
    if (CD.recsCache[pid]) { draw(merge(CD.recsCache[pid])); return; }
    fetch(cdRoot() + 'recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { CD.recsCache[pid] = d.products || []; draw(merge(CD.recsCache[pid])); })
      .catch(function () { draw(fb); });
  };
  CD.bindBody = function () {
    var body = $('[data-bw-cart-body]', CD.el); if (!body) return;
    $$('[data-bw-cart-close]', CD.el).forEach(function (b) { if (!b._bw) { b._bw = true; b.addEventListener('click', CD.close); } });
    $$('.bw-cd__item', body).forEach(function (li) {
      var key = li.getAttribute('data-key'), title = ($('.bw-cd__name', li) || {}).textContent;
      $$('[data-bw-cart-qty]', li).forEach(function (b) { b.addEventListener('click', function () { CD.change(key, parseInt(b.getAttribute('data-bw-cart-qty'), 10), title); }); });
      var inp = $('[data-bw-cart-qty-input]', li);
      if (inp) inp.addEventListener('change', function () { var q = parseInt(inp.value, 10); CD.change(key, isNaN(q) ? 1 : Math.min(99, q), title); });
    });
    var n = parseInt(body.getAttribute('data-count'), 10) || 0;
    if (!n) { try { localStorage.removeItem(TIMER_KEY); } catch (e) {} clearInterval(CD.timerInt); }
    else CD.tick();
    CD.recs();
  };
  function initCartDrawer() {
    if (!CD.enabled()) return;
    CD.bindBody();
    $$('.bw-header__cart, a[href="' + BW.routes.cart + '"][data-bw-open-cart]').forEach(function (a) {
      a.setAttribute('aria-haspopup', 'dialog'); a.setAttribute('aria-controls', 'BwCartDrawer'); a.setAttribute('aria-expanded', 'false');
      a.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); CD.refresh().then(CD.open); CD.open(); });
    });
    document.addEventListener('keydown', function (e) {
      if (!CD.el.classList.contains('is-open')) return;
      if (e.key === 'Escape') { CD.close(); return; }
      if (e.key === 'Tab') {
        var f = CD.focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Header drawer ---------- */
  function initDrawer() {
    $$('[data-bw-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('aria-controls'));
        if (!d) return;
        d.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
        var close = $('[data-bw-drawer-close]', d); if (close) close.focus();
      });
    });
    $$('[data-bw-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        var d = el.closest('.bw-drawer'); d.classList.remove('is-open');
        $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('.bw-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    });
  }

  /* ---------- Header: compact sticky state + search panel ---------- */
  function initHeader() {
    $$('[data-bw-header]').forEach(function (h) {
      if (h._bw) return; h._bw = true;
      var ticking = false;
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { h.classList.toggle('is-scrolled', window.scrollY > 24); ticking = false; });
      }
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      $$('[data-bw-search-toggle]', h).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls')); if (!panel) return;
          var open = panel.hidden;
          panel.hidden = !open;
          $$('[aria-controls="' + panel.id + '"]', h).forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
          if (open) { var i = $('input[type=search]', panel); if (i) i.focus(); }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        $$('.bw-header__search', h).forEach(function (p) { p.hidden = true; });
      });
    });
  }

  /* ---------- Carousels (testimonials) ---------- */
  function initCarousels(root) {
    $$('[data-bw-carousel]', root).forEach(function (c) {
      if (c._bw) return; c._bw = true;
      var track = $('.bw-carousel__track', c);
      function step() { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 20 : 300; }
      $$('[data-bw-prev]', c).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      $$('[data-bw-next]', c).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGalleries(root) {
    $$('[data-bw-gallery]', root).forEach(function (g) {
      if (g._bw) return; g._bw = true;
      var track = $('.bw-gallery__track', g);
      var thumbs = $$('.bw-gallery__thumb', g);
      /* only visible slides/thumbs count (per-kit galleries hide the other kits' sets) */
      function vSlides() { return Array.prototype.filter.call(track.children, function (el) { return !el.hidden; }); }
      function vThumbs() { return thumbs.filter(function (t) { return !t.hidden; }); }
      function markThumb(c) { vThumbs().forEach(function (t, i) { t.classList.toggle('is-active', i === c); t.setAttribute('aria-current', i === c ? 'true' : 'false'); }); }
      /* slide offsets (works for full-width slides and for peek slides narrower than the track) */
      function offsetOf(el) { return el ? el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft : 0; }
      function go(i) {
        var vs = vSlides(), n = vs.length || 1; i = (i + n) % n;
        track.scrollTo({ left: offsetOf(vs[i]), behavior: 'smooth' });
      }
      function current() {
        var vs = vSlides(), best = 0, bd = Infinity, x = track.scrollLeft;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2 && vs.length) return vs.length - 1;
        vs.forEach(function (el, i) { var d = Math.abs(offsetOf(el) - x); if (d < bd) { bd = d; best = i; } });
        return best;
      }
      /* Desktop grid mode (kit pages, Hismile style): show the first N visible tiles + a "View all" button */
      var more = $('[data-bw-gallery-more]', g), gmax = parseInt(g.getAttribute('data-grid-max'), 10) || 0;
      function gridLayout() {
        if (!gmax) return;
        var vs = vSlides(), open = g.classList.contains('is-expanded');
        Array.prototype.forEach.call(track.children, function (el) { el.classList.remove('is-overflow'); });
        vs.forEach(function (el, i) { if (!open && i >= gmax) el.classList.add('is-overflow'); });
        if (more) {
          more.hidden = vs.length <= gmax;
          var lab = $('[data-bw-more-label]', more);
          if (lab) lab.textContent = open ? 'Show fewer' : 'View all ' + vs.length + ' photos & videos';
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }
      if (more) more.addEventListener('click', function () {
        var open = !g.classList.contains('is-expanded');
        g.classList.toggle('is-expanded', open); gridLayout();
        if (!open) g.scrollIntoView({ block: 'nearest' });
      });
      gridLayout();
      var prev = $('.bw-gallery__arrow--prev', g), next = $('.bw-gallery__arrow--next', g);
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(vThumbs().indexOf(t)); }); });
      /* switch to a kit's slide set; returns false if this gallery has no set for that kit */
      g._bwKit = function (kit) {
        if (!kit || !track.querySelector('[data-kit="' + kit + '"]')) return false;
        $$('[data-kit]', g).forEach(function (el) { el.hidden = el.getAttribute('data-kit') !== kit; });
        track.scrollTo({ left: 0, behavior: 'auto' }); markThumb(0); gridLayout();
        if (window.BWHowMedia) window.BWHowMedia.scan(g);
        return true;
      };
      /* Show a media item by id (if it is in this product's gallery), otherwise swap the first
         slide's image for the given src (bundle tiers that point at a different product). */
      var swapped = null;
      function restore() {
        if (!swapped) return;
        swapped.forEach(function (r) { r.el.src = r.src; if (r.srcset) r.el.setAttribute('srcset', r.srcset); else r.el.removeAttribute('srcset'); if (r.sizes) r.el.setAttribute('sizes', r.sizes); r.el.alt = r.alt; });
        swapped = null;
      }
      function swapImg(img, src, alt) {
        if (!img) return;
        swapped.push({ el: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes'), alt: img.alt });
        img.removeAttribute('srcset'); img.src = src; if (alt != null) img.alt = alt;
      }
      g._bwShow = function (opts) {
        opts = opts || {};
        if (opts.kit && g._bwKit(opts.kit)) {
          restore();
          if (opts.sticky) $$('.bw-sticky__img img').forEach(function (im) { im.removeAttribute('srcset'); im.src = opts.sticky; });
          return;
        }
        var slides = Array.prototype.slice.call(track.children), idx = -1;
        if (opts.mediaId) slides.forEach(function (sl, i) { if (idx < 0 && sl.getAttribute('data-media-id') === String(opts.mediaId)) idx = i; });
        if (opts.asset) slides.forEach(function (sl, i) { if (idx < 0 && sl.getAttribute('data-asset') === opts.asset) idx = i; });
        if (idx > -1) { restore(); track.scrollTo({ left: offsetOf(slides[idx]), behavior: opts.instant ? 'auto' : 'smooth' }); return; }
        if (!opts.src) { restore(); return; }
        restore(); swapped = [];
        swapImg($('img', slides[0]), opts.src, opts.alt);
        if (thumbs[0]) swapImg($('img', thumbs[0]), opts.thumb || opts.src, '');
        if (opts.sticky) $$('.bw-sticky__img img').forEach(function (im) { swapImg(im, opts.sticky, ''); });
        track.scrollTo({ left: 0, behavior: opts.instant ? 'auto' : 'smooth' });
      };
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          markThumb(current());
        });
      });
    });
  }

  /* ---------- Before / after ---------- */
  function initBeforeAfter(root) {
    $$('[data-bw-ba]', root).forEach(function (el) {
      var input = $('input[type=range]', el);
      if (!input || input._bw) return; input._bw = true;
      function set() { el.style.setProperty('--pos', input.value + '%'); }
      input.addEventListener('input', set); set();
    });
  }

  /* ---------- Reveal (stat bars) ---------- */
  function initReveal(root) {
    var els = $$('.bw-stat', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- FAQ tabs ---------- */
  function initTabs(root) {
    $$('[data-bw-tabs]', root).forEach(function (wrap) {
      if (wrap._bw) return; wrap._bw = true;
      var tabs = $$('[role=tab]', wrap);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab; t.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
          });
        });
      });
    });
  }


  /* ---------- FAQ search + #anchor deep links ---------- */
  function initFaq(root) {
    $$('[data-bw-faq]', root).forEach(function (wrap) {
      if (wrap._bwFaq) return; wrap._bwFaq = true;
      var input = wrap.querySelector('[data-bw-faq-search]'), empty = wrap.querySelector('[data-bw-faq-empty]');
      var tabs = wrap.querySelector('.bw-faq__tabs'), panels = $$('.bw-faq__panel', wrap), items = $$('details.bw-acc', wrap);
      function showTabFor(el) {
        var panel = el.closest('.bw-faq__panel'); if (!panel) return;
        var tab = wrap.querySelector('[aria-controls="' + panel.id + '"]'); if (tab) tab.click();
      }
      if (input) input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase(), hits = 0;
        if (!q) {
          items.forEach(function (d) { d.hidden = false; });
          if (tabs) { tabs.hidden = false; var sel = wrap.querySelector('[role=tab][aria-selected=true]') || wrap.querySelector('[role=tab]'); sel && sel.click(); }
          else panels.forEach(function (p) { p.hidden = false; });
          if (empty) empty.hidden = true; return;
        }
        if (tabs) tabs.hidden = true;
        panels.forEach(function (p) { p.hidden = false; });
        items.forEach(function (d) { var m = d.textContent.toLowerCase().indexOf(q) > -1; d.hidden = !m; if (m) hits++; });
        panels.forEach(function (p) { p.hidden = !$$('details.bw-acc', p).some(function (d) { return !d.hidden; }); });
        if (empty) empty.hidden = hits > 0;
      });
      function openHash() {
        var id = decodeURIComponent((location.hash || '').slice(1)); if (!id) return;
        var el = document.getElementById(id); if (!el || !wrap.contains(el) || el.tagName !== 'DETAILS') return;
        showTabFor(el); el.open = true; setTimeout(function () { el.scrollIntoView({ block: 'center' }); }, 60);
      }
      openHash(); window.addEventListener('hashchange', openHash);
    });
  }

  /* ---------- Video facade (loads the player only on click) ---------- */
  function initVideos(root) {
    $$('[data-bw-video]', root).forEach(function (f) {
      if (f._bw) return; f._bw = true;
      var btn = f.querySelector('.bw-video__play'); if (!btn) return;
      btn.addEventListener('click', function () {
        var ifr = document.createElement('iframe');
        ifr.src = f.getAttribute('data-embed'); ifr.title = f.getAttribute('data-title') || 'Video';
        ifr.allow = 'autoplay; fullscreen; picture-in-picture'; ifr.allowFullscreen = true; ifr.setAttribute('frameborder', '0');
        f.innerHTML = ''; f.appendChild(ifr); f.classList.add('is-playing'); ifr.focus();
      });
    });
  }

  /* ---------- Track your order: open the carrier's official tracking page ---------- */
  var BW_CARRIERS = {
    auspost: 'https://auspost.com.au/mypost/track/details/{n}',
    startrack: 'https://startrack.com.au/track/details/{n}',
    aramex: 'https://www.aramex.com.au/tools/track?l={n}',
    dhl: 'https://www.dhl.com/global-en/home/tracking/tracking-express.html?submit=1&tracking-id={n}',
    usps: 'https://tools.usps.com/go/TrackConfirmAction?tLabels={n}'
  };
  var BW_CARRIER_NAMES = { auspost: 'Australia Post', startrack: 'StarTrack', aramex: 'Aramex', dhl: 'DHL', usps: 'USPS' };
  function bwDetectCarrier(n) {
    if (/^(94|93|92|95|420\d{5,9}9)\d{15,25}$/.test(n) || /^\d{20,22}$/.test(n) || /^[A-Z]{2}\d{9}US$/.test(n)) return 'usps';
    if (/^\d{10}$/.test(n) || /^JJD\d+$/.test(n) || /^(JVGL|GM|LX|RX)\w{8,}$/.test(n) && !/AU$/.test(n)) return 'dhl';
    if (/^\d{12}$/.test(n) || /^[A-Z]{2}\d{10}$/.test(n)) return 'aramex';
    if (/^[A-Z]{3}Z\d{8}$/.test(n) || /^[A-Z0-9]{3}Z\d+/.test(n)) return 'startrack';
    return 'auspost';
  }
  function initTrack(root) {
    $$('[data-bw-track]', root).forEach(function (form) {
      if (form._bw) return; form._bw = true;
      var msg = form.querySelector('.bw-track__msg');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = (form.tracking.value || '').replace(/\s+/g, '').toUpperCase();
        if (!n) { msg.textContent = 'Please enter your tracking number.'; form.tracking.focus(); return; }
        var c = form.carrier.value === 'auto' ? bwDetectCarrier(n) : form.carrier.value;
        var url = BW_CARRIERS[c].replace('{n}', encodeURIComponent(n));
        var w = window.open(url, '_blank', 'noopener');
        msg.innerHTML = 'Opening ' + BW_CARRIER_NAMES[c] + ' tracking in a new tab. ' + (w ? '' : 'If nothing opened, ') + '<a href="' + url + '" target="_blank" rel="noopener">Open it here</a>.';
      });
    });
  }

  /* ---------- Mini review rotator ---------- */
  function initRotators(root) {
    $$('[data-bw-rotator]', root).forEach(function (r) {
      if (r._bw) return; r._bw = true;
      var items = $$('.bw-mini-review__item', r); if (items.length < 2) return;
      var i = 0, ms = (parseInt(r.getAttribute('data-interval'), 10) || 5) * 1000, paused = false;
      r.addEventListener('mouseenter', function () { paused = true; });
      r.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(d, n) {
    var date = new Date(d);
    while (n > 0) { date.setDate(date.getDate() + 1); var w = date.getDay(); if (w !== 0 && w !== 6) n--; }
    return date;
  }
  function initEta(root) {
    $$('[data-bw-eta]', root).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 1, max = parseInt(el.getAttribute('data-max'), 10) || 3;
      var opts = { weekday: 'short', day: 'numeric', month: 'short' };
      var a = addBusinessDays(new Date(), min).toLocaleDateString(undefined, opts);
      var b = addBusinessDays(new Date(), max).toLocaleDateString(undefined, opts);
      var out = $('[data-bw-eta-date]', el); if (out) out.textContent = min === max ? a : a + ' – ' + b;
    });
  }

  /* ---------- Delivery line: "Free standard delivery" only when the viewed item qualifies ---------- */
  document.addEventListener('bw:item-total', function (e) {
    var total = e.detail && e.detail.total; if (total == null) return;
    $$('[data-bw-eta-ship]').forEach(function (el) {
      var th = parseInt(el.getAttribute('data-threshold'), 10) || BW.shipGoalCents || 7900;
      if (BW.shipFx) th = Math.round(th * BW.fxRate());
      var free = total >= th;
      var f = $('[data-eta-free]', el), p = $('[data-eta-paid]', el);
      if (f) f.hidden = !free; if (p) p.hidden = free;
    });
  });

  /* ---------- Countdown (to local midnight) ---------- */
  function initCountdowns(root) {
    $$('[data-bw-countdown]', root).forEach(function (el) {
      function tick() {
        var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
        var s = Math.max(0, Math.floor((end - now) / 1000));
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        el.textContent = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Free shipping / gift progress ---------- */
  function renderProgress(el, totalCents) {
    var ms = JSON.parse(el.getAttribute('data-milestones') || '[]');
    if (!ms.length) return;
    if (BW.shipFx) ms.forEach(function (m) { m.amount = Math.round(m.amount * BW.fxRate()); });
    var max = ms[ms.length - 1].amount;
    /* Product page: the item being viewed (at the price the customer pays) counts too, so "A$X away" is never more than
       what this item alone leaves to go. */
    var item0 = el._bwItem || 0;
    if (item0 > totalCents && item0 < max) totalCents = item0;
    var pct = Math.min(100, (totalCents / max) * 100);
    var fill = $('.bw-progress__fill', el); if (fill) fill.style.width = pct + '%';
    $$('.bw-progress__ms', el).forEach(function (m, i) { m.classList.toggle('is-reached', totalCents >= ms[i].amount); });
    var next = null;
    for (var i = 0; i < ms.length; i++) { if (totalCents < ms[i].amount) { next = ms[i]; break; } }
    var msg = $('.bw-progress__msg', el); if (!msg) return;
    var item = el._bwItem || 0;
    if (next && item >= max && el.getAttribute('data-msg-item')) {
      if (fill) fill.style.width = '100%';
      $$('.bw-progress__ms', el).forEach(function (m) { m.classList.add('is-reached'); });
      msg.innerHTML = '<strong>' + escapeHtml(el.getAttribute('data-msg-item')) + '</strong>';
    } else if (next) {
      var tpl = el.getAttribute('data-msg-progress') || "You're [amount] away from [reward]";
      msg.innerHTML = escapeHtml(tpl).replace('[amount]', '<strong>' + BW.formatMoney(next.amount - totalCents) + '</strong>').replace('[reward]', '<strong>' + escapeHtml(next.label) + '</strong>');
    } else {
      msg.innerHTML = '<strong>' + escapeHtml(el.getAttribute('data-msg-done') || 'All rewards unlocked!') + '</strong>';
    }
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function initProgress() {
    var els = $$('[data-bw-progress]');
    if (!els.length) return;
    els.forEach(function (el) { el._bwItem = BW._itemTotal || 0; el._bwCart = parseInt(el.getAttribute('data-cart-total'), 10) || 0; renderProgress(el, el._bwCart); });
    document.addEventListener('bw:cart-updated', function (e) {
      els.forEach(function (el) { el._bwCart = e.detail.total_price; renderProgress(el, el._bwCart); });
    });
    document.addEventListener('bw:item-total', function (e) {
      els.forEach(function (el) { el._bwItem = e.detail.total || 0; renderProgress(el, el._bwCart || 0); });
    });
  }

  /* ---------- Upgrade & Save add-ons ---------- */
  function initUpsells(root) {
    $$('[data-bw-upsell-add]', root).forEach(function (btn) {
      if (btn._bw) return; btn._bw = true;
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id'); if (!id) return;
        btn.classList.add('is-loading');
        BW.addToCart([{ id: parseInt(id, 10), quantity: 1 }])
          .then(function () {
            btn.classList.remove('is-loading'); btn.classList.add('is-added');
            btn.setAttribute('aria-label', btn.getAttribute('data-added-label') || 'Added');
            if (BW.afterAdd(btn.getAttribute('data-title'))) return;
            BW.toast((btn.getAttribute('data-title') || 'Item') + ' added to cart', true);
            return BW.refreshCart();
          })
          .catch(function (err) { btn.classList.remove('is-loading'); BW.toast(err.message); });
      });
    });
  }

  /* ---------- Main product buy box ---------- */
  function ProductForm(root) {
    this.root = root;
    this.form = $('form[data-bw-form]', root);
    if (!this.form) return;
    this.idInput = $('input[name="id"]', this.form);
    this.qtyInput = $('[data-bw-qty-input]', root);
    this.planInput = $('input[name="selling_plan"]', this.form);
    this.subToggle = $('[data-bw-subscribe]', root);
    this.variantSelect = $('[data-bw-variant-select]', root);
    this.atc = $('[data-bw-atc]', root);
    this.redirect = root.getAttribute('data-after-add') || 'toast';
    this.bind();
    this.update();
    this.showMedia(true);
  }
  ProductForm.prototype.selectedTier = function () { return $('input[data-bw-tier]:checked', this.root); };
  ProductForm.prototype.state = function () {
    var tier = this.selectedTier(), s = {};
    if (tier) {
      s.id = tier.getAttribute('data-variant-id');
      s.price = parseInt(tier.getAttribute('data-price'), 10);
      s.compare = parseInt(tier.getAttribute('data-compare'), 10) || 0;
      s.qtyMultiplier = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      s.plan = tier.getAttribute('data-plan') || '';
      s.planPrice = parseInt(tier.getAttribute('data-plan-price'), 10) || 0;
      s.available = tier.getAttribute('data-available') !== 'false';
    } else if (this.variantSelect) {
      var o = this.variantSelect.options[this.variantSelect.selectedIndex];
      s.id = o.value; s.price = parseInt(o.getAttribute('data-price'), 10); s.compare = parseInt(o.getAttribute('data-compare'), 10) || 0;
      s.qtyMultiplier = 1; s.plan = o.getAttribute('data-plan') || ''; s.planPrice = parseInt(o.getAttribute('data-plan-price'), 10) || 0;
      s.available = o.getAttribute('data-available') !== 'false';
    } else {
      s.id = this.idInput.value; s.price = parseInt(this.root.getAttribute('data-price'), 10); s.compare = parseInt(this.root.getAttribute('data-compare'), 10) || 0;
      s.qtyMultiplier = 1; s.plan = this.root.getAttribute('data-plan') || ''; s.planPrice = parseInt(this.root.getAttribute('data-plan-price'), 10) || 0;
      s.available = this.root.getAttribute('data-available') !== 'false';
    }
    s.qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
    s.subscribed = !!(this.subToggle && this.subToggle.checked && s.plan);
    s.unit = s.subscribed && s.planPrice ? s.planPrice : s.price;
    s.total = s.unit * s.qty * s.qtyMultiplier;
    s.compareTotal = (s.compare > s.unit ? s.compare : 0) * s.qty * s.qtyMultiplier;
    return s;
  };
  ProductForm.prototype.showMedia = function (instant) {
    var g = $('[data-bw-gallery]', this.root); if (!g || !g._bwShow) return;
    var tier = this.selectedTier(), el = null;
    if (tier) el = tier;
    else if (this.variantSelect) el = this.variantSelect.options[this.variantSelect.selectedIndex];
    if (!el) return;
    g._bwShow({
      mediaId: el.getAttribute('data-media-id'), kit: el.getAttribute('data-kit-handle'), asset: el.getAttribute('data-asset'), src: el.getAttribute('data-image'), thumb: el.getAttribute('data-thumb'),
      sticky: el.getAttribute('data-thumb'), alt: el.getAttribute('data-image-alt'), instant: instant
    });
  };
  ProductForm.prototype.bind = function () {
    var self = this;
    $$('input[data-bw-tier]', this.root).forEach(function (r) { r.addEventListener('change', function () { self.update(); self.showMedia(); }); });
    if (this.variantSelect) {
      /* deep link: ?variant=123 selects that variant (Dawn behaviour) */
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if (m) { for (var i = 0; i < this.variantSelect.options.length; i++) if (this.variantSelect.options[i].value === m[1]) this.variantSelect.selectedIndex = i; }
      this.variantSelect.addEventListener('change', function () {
        self.update(); self.showMedia();
        var id = self.variantSelect.value;
        if (id && window.history && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); }
      });
    }
    /* Dawn variant pickers (if a Dawn product block is used on the same page) */
    document.addEventListener('change', function (e) {
      var picker = e.target.closest && e.target.closest('variant-selects, variant-radios');
      if (!picker) return;
      setTimeout(function () {
        var idInput = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
        var id = idInput && idInput.value; if (!id || !self.variantSelect) return;
        for (var i = 0; i < self.variantSelect.options.length; i++) if (self.variantSelect.options[i].value === id) { self.variantSelect.selectedIndex = i; self.update(); self.showMedia(); }
      }, 60);
    });
    if (this.subToggle) this.subToggle.addEventListener('change', function () { self.update(); });
    $$('[data-bw-qty]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(self.qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-bw-qty'), 10);
        self.qtyInput.value = Math.max(1, Math.min(99, v)); self.update();
      });
    });
    if (this.qtyInput) this.qtyInput.addEventListener('change', function () { self.update(); });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    $$('[data-bw-sticky-atc]').forEach(function (b) { b.addEventListener('click', function () { self.submit(); }); });
  };
  ProductForm.prototype.update = function () {
    var s = this.state(), root = this.root;
    if (this.idInput && s.id) this.idInput.value = s.id;
    var formQty = $('input[name="quantity"]', this.form);
    if (formQty) formQty.value = s.qty * s.qtyMultiplier;
    if (this.planInput) { this.planInput.value = s.subscribed ? s.plan : ''; this.planInput.disabled = !s.subscribed; }
    if (this.subToggle) {
      var wrap = this.subToggle.closest('.bw-sub-toggle');
      var canSub = !!s.plan;
      if (wrap) wrap.classList.toggle('is-disabled', !canSub && !wrap.hasAttribute('data-preview'));
    }
    var unitText = BW.formatMoney(s.unit * s.qtyMultiplier);
    $$('[data-bw-price-now]', root).forEach(function (el) { el.textContent = unitText; });
    $$('[data-bw-price-was]', root).forEach(function (el) {
      var c = s.compare > s.unit ? s.compare * s.qtyMultiplier : 0;
      el.textContent = c ? BW.formatMoney(c) : ''; el.hidden = !c;
    });
    $$('[data-bw-price-save]', root).forEach(function (el) {
      var c = s.compare > s.unit ? s.compare : 0;
      if (!c) { el.hidden = true; return; }
      el.hidden = false;
      var pct = Math.round(((c - s.unit) / c) * 100);
      el.textContent = (el.getAttribute('data-template') || 'Save [percent]%').replace('[percent]', pct).replace('[amount]', BW.formatMoney((c - s.unit) * s.qtyMultiplier));
    });
    var totalText = BW.formatMoney(s.total);
    $$('[data-bw-atc-price]').forEach(function (el) { el.textContent = totalText; });
    /* Earn-credit line (sections/bw-main-product.liquid): Credit percent of the shown price (selected variant / kit tier / gel pack),
       rounded to whole currency units, same as the Liquid render. */
    $$('[data-bw-earn]', root).forEach(function (el) {
      var pct = parseFloat(el.getAttribute('data-pct')) || 0;
      var c = BW.earnCents(s.unit * s.qtyMultiplier, pct);
      var amt = $('[data-bw-earn-amt]', el); if (amt) amt.textContent = BW.formatWhole(c);
      el.hidden = !(c > 0);
    });
    /* Sitewide code (Tap to apply, BW.sale below). Before applying: real price + apply button. Once the code is genuinely
       applied (Shopify discount cookie / cart), the real price is struck through and the price after the code shows
       (rounded to the cent like Shopify's % discount). On the BOGO product (Value Pack) the free-pack box stays the main
       offer; with 2+ packs the free pack wins (codes don't combine), so the code price isn't shown then. */
    var saleWrap = $('[data-bw-sale]', root), effTotal = s.total;
    if (saleWrap) {
      var tierSel = this.selectedTier(), bh = saleWrap.getAttribute('data-bogo-handle') || '';
      var curH = tierSel && tierSel.getAttribute('data-kit-handle') ? tierSel.getAttribute('data-kit-handle') : saleWrap.getAttribute('data-current');
      var isBogo = !!bh && curH === bh;
      var pct = parseFloat(saleWrap.getAttribute('data-pct')) || 0;
      var applied = pct > 0 && BW.sale && BW.sale.applied(saleWrap.getAttribute('data-code'));
      var bogoWins = isBogo && s.qty >= 2;
      var eff = applied && !bogoWins && s.unit > 0;
      var after = function (c) { return Math.round(c * (100 - pct) / 100); };
      var st8 = saleWrap.getAttribute('data-state');
      if (applied && st8 !== 'applied' && st8 !== 'combo') saleWrap.setAttribute('data-state', st8 = 'applied');
      saleWrap.classList.toggle('is-bogo', isBogo);
      var show = function (sel, on) { $$(sel, saleWrap).forEach(function (el) { el.hidden = !on; }); };
      show('[data-bw-apply-std]', !isBogo); show('[data-bw-apply-bogo]', isBogo);
      show('[data-bw-sale-offer]', st8 === 'idle' || st8 === 'busy');
      show('[data-bw-sale-fail]', st8 === 'failed');
      show('[data-bw-sale-combo]', st8 === 'combo');
      show('[data-bw-sale-bogo-note]', isBogo && st8 !== 'applied' && st8 !== 'combo');
      show('[data-bw-sale-bogo-applied]', isBogo && st8 === 'applied');
      var row = $('[data-bw-price-row]', root), afterEl = $('[data-bw-price-after]', root), lab = $('[data-bw-applied]', root);
      var unitAfter = after(s.unit * s.qtyMultiplier);
      if (row) {
        var was = row.classList.contains('is-applied');
        row.classList.toggle('is-applied', eff);
        if (afterEl) {
          afterEl.hidden = !eff;
          var amt = $('[data-bw-price-after-amt]', afterEl);
          if (amt) {
            if (eff && !was && BW.sale.animateNext) BW.sale.countDown(amt, s.unit * s.qtyMultiplier, unitAfter);
            else amt.textContent = BW.formatMoney(unitAfter);
          }
        }
        if (eff && !was && BW.sale.animateNext) { row.classList.add('is-animating'); setTimeout(function () { row.classList.remove('is-animating'); }, 900); }
        if (eff) $$('[data-bw-price-was], [data-bw-price-save]', row).forEach(function (el) { el.hidden = true; });
      }
      if (lab) lab.hidden = !eff;
      if (eff) effTotal = after(s.total);
      $$('[data-bw-sticky-sale]').forEach(function (el) {
        el.hidden = !eff;
        var w = $('[data-bw-sticky-was]', el); if (w) w.textContent = BW.formatMoney(s.total);
      });
    }
    if (this.kitPrice) effTotal = this.kitPrice(s, effTotal);
    if (effTotal !== s.total) $$('[data-bw-atc-price]').forEach(function (el) { el.textContent = BW.formatMoney(effTotal); });
    BW.sale && (BW.sale.animateNext = false);
    /* heading + sticky title follow the selected kit/tier */
    var tierEl = this.selectedTier(), tTitle = tierEl && tierEl.getAttribute('data-product-title');
    if (tTitle) {
      $$('.bw-product__title', root).forEach(function (el) { el.textContent = tTitle; });
      $$('.bw-sticky__title').forEach(function (el) { el.textContent = tTitle; });
    }
    /* Free-delivery line + bar use what the customer actually pays (after an applied code), like Shopify's price-based
       shipping rates, which are checked against the order value after discounts. */
    BW._itemTotal = effTotal;
    document.dispatchEvent(new CustomEvent('bw:item-total', { detail: { total: effTotal, listTotal: s.total } }));
    $$('[data-bw-afterpay-amount]', root).forEach(function (el) {
      var n = parseInt(el.getAttribute('data-installments'), 10) || 4;
      el.textContent = BW.formatMoney(Math.ceil(effTotal / n));
    });
    if (this.atc) {
      this.atc.disabled = !s.available;
      var label = $('[data-bw-atc-label]', this.atc);
      if (label) label.textContent = s.available ? this.atc.getAttribute('data-label') : this.atc.getAttribute('data-soldout');
    }
  };
  /* Kit price mode (sections/bw-main-product.liquid, [data-bw-kp]): every kit price is what checkout charges with the sitewide
     code assumed on. BOGO kit while the free 2nd pack is live: full price for 2 packs (the code can't combine), 2 x price struck
     through. Other kits: price after the code, real price struck through. Returns the total the Add to cart / sticky buttons show. */
  ProductForm.prototype.kitPrice = function (s, effTotal) {
    var kp = $('[data-bw-kp]', this.root); if (!kp) return effTotal;
    var pct = parseFloat(kp.getAttribute('data-pct')) || 0, code = kp.getAttribute('data-code') || '';
    var tier = this.selectedTier(), bh = kp.getAttribute('data-bogo-handle') || '';
    var curH = tier && tier.getAttribute('data-kit-handle') ? tier.getAttribute('data-kit-handle') : kp.getAttribute('data-current');
    var end = parseInt(kp.getAttribute('data-bw-bogo-end-at'), 10) || 0;
    var bogo = !!bh && curH === bh && kp.getAttribute('data-bogo-live') === 'true' && !(end > 0 && Date.now() / 1000 >= end);
    var applied = !!(BW.sale && BW.sale.applied(code)), st8 = kp.getAttribute('data-state');
    var base = s.unit * s.qtyMultiplier, now, was, note, save, total;
    var fm = BW.formatMoney, after = function (c) { return Math.round(c * (100 - pct) / 100); };
    if (bogo) {
      now = base; was = base * 2; total = s.total; save = '2nd kit FREE';
      note = 'Buy 1 Get 1 Free · better than ' + code + " (codes can't be combined)";
    } else if (applied) {
      /* the customer tapped Apply code and Shopify confirmed it: show what checkout will charge */
      now = after(base); was = base; total = after(s.total); save = pct + '% off';
      note = code + ' applied ✓';
    } else {
      /* Lex 6 Oct: full price; the code is only a small secondary line with Apply / Copy */
      now = base; was = base; total = s.total; save = '';
      note = 'Save ' + pct + '% with code <strong>' + code + '</strong>';
    }
    var showWas = bogo || applied;
    var set = function (sel, v, html) { $$(sel, kp).forEach(function (el) { if (html) el.innerHTML = v; else el.textContent = v; }); };
    set('[data-bw-kp-now]', fm(now)); set('[data-bw-kp-was]', fm(was)); set('[data-bw-kp-save]', save); set('[data-bw-kp-note]', note, true);
    $$('[data-bw-kp-was], [data-bw-kp-save]', kp).forEach(function (el) { el.hidden = !showWas; });
    $$('[data-bw-sale-offer]', kp).forEach(function (el) { el.hidden = bogo || applied || !(st8 === 'idle' || st8 === 'busy'); });
    $$('[data-bw-sale-fail]', kp).forEach(function (el) { el.hidden = bogo || st8 !== 'failed'; });
    $$('[data-bw-sale-combo]', kp).forEach(function (el) { el.hidden = st8 !== 'combo'; });
    $$('[data-bw-sticky-sale]').forEach(function (el) {
      el.hidden = !showWas;
      var w = $('[data-bw-sticky-was]', el); if (w) w.textContent = fm(was * s.qty);
      var ok = $('.bw-sticky__ok', el); if (ok) ok.textContent = bogo ? 'Buy 1 Get 1 Free' : (applied ? code + ' applied ✓' : 'with code ' + code);
    });
    /* note under Add to cart: the button shows the code price, so say the code must be entered (Lex: no auto-apply) */
    $$('[data-bw-atc-note]', this.root).forEach(function (el) {
      el.hidden = true; /* Add to cart now shows the full price unless the code is genuinely applied */
      var t = $('[data-bw-atc-note-text]', el); if (t) t.innerHTML = applied ? code + ' applied ✓' : 'Price with code <strong>' + code + '</strong> – enter it at checkout or tap Apply code';
    });
    return total;
  };
  ProductForm.prototype.submit = function () {
    var self = this, s = this.state();
    if (!s.available) return;
    var item = { id: parseInt(s.id, 10), quantity: s.qty * s.qtyMultiplier };
    if (s.subscribed) item.selling_plan = parseInt(s.plan, 10);
    if (this.atc) this.atc.classList.add('is-loading');
    BW.addToCart([item])
      .then(function () {
        if (self.redirect === 'cart') { window.location.href = BW.routes.cart; return; }
        if (self.redirect === 'checkout') { window.location.href = '/checkout'; return; }
        if (BW.afterAdd(($('.bw-product__title', self.root) || {}).textContent)) return;
        BW.toast(self.root.getAttribute('data-added-text') || 'Added to cart', true);
        return BW.refreshCart();
      })
      .catch(function (err) { BW.toast(err.message); })
      .then(function () { if (self.atc) self.atc.classList.remove('is-loading'); });
  };

  function initProducts(root) {
    $$('[data-bw-product]', root).forEach(function (el) { if (!el._bw) { el._bw = new ProductForm(el); } });
  }

  /* ---------- Sticky ATC bar ---------- */
  function initSticky() {
    var bar = $('.bw-sticky'); var atc = $('[data-bw-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    /* phones: price + Add to cart visible from the first screen until the real button is on screen;
       desktop: only after scrolling past the buy box */
    var mq = window.matchMedia('(max-width: 749px)');
    /* --bw-sticky-clear: space the bar takes at the bottom of the viewport (height + bottom gap); the Inbox chat launcher and
       the hCaptcha badge sit above it while the bar is visible (bw-theme.css) */
    function setClear() {
      var h = bar.offsetHeight; if (!h) return;
      document.documentElement.style.setProperty('--bw-sticky-clear', Math.ceil(h + (parseFloat(getComputedStyle(bar).bottom) || 0)) + 'px');
    }
    setClear();
    if ('ResizeObserver' in window) new ResizeObserver(setClear).observe(bar); else window.addEventListener('resize', setClear);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !en.isIntersecting && (past || mq.matches));
      });
    }).observe(atc);
  }
  /* "Which kit is right for me?" - on a kit page, pick the tier in place instead of leaving the page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bw-choose]'); if (!a) return;
    var r = document.querySelector('input[data-bw-tier][data-product-id="' + a.getAttribute('data-bw-choose') + '"]');
    if (!r) return;
    e.preventDefault(); r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
    var box = r.closest('.bw-tiers') || r; box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function init(root) {
    initCarousels(root); initGalleries(root); initBeforeAfter(root); initReveal(root); initTabs(root); initFaq(root); initVideos(root); initTrack(root);
    initRotators(root); initEta(root); initCountdowns(root); initUpsells(root); initProducts(root); initHowSteps(root);
  }


  /* ---------- "How does it work?" steps: click/hover/swipe switches the image; auto-advance until interaction ---------- */
  function initHowSteps(root) {
    $$('[data-bw-howsteps]', root).forEach(function (sec) {
      if (sec._bwHow) return; sec._bwHow = true;
      var tabs = $$('[data-bw-howstep]', sec), imgs = $$('[data-bw-howstep-img]', sec), dots = $$('.bw-howsteps__dot', sec);
      var n = Math.min(tabs.length, imgs.length); if (n < 2) return;
      var ms = parseInt(sec.getAttribute('data-interval'), 10) || 4000, cur = 0, timer = null, stopped = false, inView = false;
      sec.style.setProperty('--bw-how-interval', ms + 'ms');
      function show(i) {
        cur = (i + n) % n;
        tabs.forEach(function (t, k) { var on = k === cur; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
        imgs.forEach(function (im, k) { var on = k === cur; im.classList.toggle('is-active', on); if (on) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
        if (!stopped && inView) restartBar();
      }
      function restartBar() { var t = tabs[cur], b = t && t.querySelector('.bw-howsteps__bar'); if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } }
      function stopAuto() { stopped = true; clearInterval(timer); timer = null; sec.classList.remove('is-auto'); }
      function startAuto() {
        if (stopped || timer || !inView) return;
        sec.classList.add('is-auto'); restartBar();
        timer = setInterval(function () { show(cur + 1); }, ms);
      }
      function pauseAuto() { clearInterval(timer); timer = null; sec.classList.remove('is-auto'); }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { stopAuto(); show(k); });
        t.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { stopAuto(); show(k); } });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return; e.preventDefault(); stopAuto(); show(cur + d); tabs[cur].focus();
        });
      });
      tabs.forEach(function (t, k) { t.tabIndex = k === 0 ? 0 : -1; });
      var media = $('[data-bw-howsteps-media]', sec), x0 = null, y0 = null;
      if (media) {
        media.addEventListener('touchstart', function (e) { var p = e.touches[0]; x0 = p.clientX; y0 = p.clientY; }, { passive: true });
        media.addEventListener('touchend', function (e) {
          if (x0 === null) return; var p = e.changedTouches[0], dx = p.clientX - x0, dy = p.clientY - y0; x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { stopAuto(); show(cur + (dx < 0 ? 1 : -1)); }
        }, { passive: true });
        media.addEventListener('click', function () { stopAuto(); show(cur + 1); });
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) stopped = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { inView = es[0].isIntersecting; if (inView) startAuto(); else pauseAuto(); }, { threshold: 0.35 }).observe(sec);
      } else { inView = true; startAuto(); }
      show(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer(); initHeader(); init(document); initProgress(); initSticky(); initCartDrawer();
    if (!BW.preview) BW.refreshCart();
    if (BW.shipFx) {
      BW.fixShipBars(document);
      var bwShipQueued = false;
      new MutationObserver(function () {
        if (bwShipQueued) return; bwShipQueued = true;
        requestAnimationFrame(function () { bwShipQueued = false; BW.fixShipBars(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initProgress(); initHeader(); });
})();

/* Announcement rotator (phones) */
(function () {
  function initRotators() {
    document.querySelectorAll('[data-bw-announce-rotator]').forEach(function (el) {
      if (el.dataset.bwInit) return; el.dataset.bwInit = '1';
      var slides = el.querySelectorAll('.bw-announce__slide'); if (slides.length < 2) return;
      var i = 0, ms = parseInt(el.dataset.interval, 10) || 4000, timer;
      function go() {
        slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden');
      }
      function start() { stop(); timer = setInterval(go, ms); }
      function stop() { if (timer) clearInterval(timer); }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      start();
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRotators); else initRotators();
  document.addEventListener('shopify:section:load', initRotators);
})();

/* Sale code chip: tap to copy ([data-bw-copy], snippets/bw-sale-code.liquid). Delegated so re-rendered cart drawer chips work. */
(function () {
  var live;
  function announce(msg) {
    if (!live) { live = document.createElement('div'); live.className = 'bw-visually-hidden'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30);
  }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(ta);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bw-copy]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var code = b.getAttribute('data-bw-copy'), label = b.querySelector('[data-bw-copy-label]'), copied = b.getAttribute('data-copied') || 'Copied';
    var orig = label ? (label.getAttribute('data-orig') || code) : code;
    function done() {
      if (!b.classList.contains('is-copied')) b.style.minWidth = b.offsetWidth + 'px';
      if (label) label.textContent = copied;
      b.classList.add('is-copied'); announce(code + ' ' + copied.toLowerCase());
      clearTimeout(b._bwCopyT);
      b._bwCopyT = setTimeout(function () { if (label) label.textContent = orig; b.classList.remove('is-copied'); b.style.minWidth = ''; }, 2000);
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
    else { fallbackCopy(code); done(); }
  });
})();

/* Sitewide code "Tap to apply" (product page, bw-main-product). Applying is real: GET {root}discount/CODE sets Shopify's
   discount_code cookie and puts the code on the cart (cart.js discount_codes), and a cart with items also gets
   /cart/update.js {discount}. It only counts as applied when the cookie or cart confirms it, otherwise the copy
   fallback shows and no price is struck through. Remembered in localStorage (bwSaleApplied) and re-applied
   silently on later visits (Shopify's discount cookie only lasts the browser session). */
(function () {
  var BW = window.BW = window.BW || {};
  var KEY = 'bwSaleApplied', $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var up = function (c) { return String(c || '').trim().toUpperCase(); };
  function cookieCode() { var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return m ? m[1] : ''; } }
  function stored() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function cartHas(cart, code) { return !!(cart && (cart.discount_codes || []).some(function (d) { return up(d.code) === up(code); })); }
  var confirmed = {};
  var S = BW.sale = {
    animateNext: false,
    applied: function (code) { return !!code && !!confirmed[up(code)]; },
    countDown: function (el, from, to) {
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !window.requestAnimationFrame) { el.textContent = BW.formatMoney(to); return; }
      var t0 = null, dur = 700;
      (function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        el.textContent = BW.formatMoney(Math.round(from + (to - from) * e));
        if (k < 1) requestAnimationFrame(step);
      })(performance.now());
    },
    rerender: function () { $$('[data-bw-product]').forEach(function (el) { if (el._bw) el._bw.update(); }); },
    apply: function (code) {
      /* Market-aware: {root} is routes.root_url ('/', '/en-au', or '/' on a market domain such as brighterwhite.com.au) */
      var root = (BW.routes && BW.routes.root) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (root.slice(-1) !== '/') root += '/';
      var cartJs = root + 'cart.js';
      var before = null;
      /* JSON fetch with one retry (the storefront rate-limits with 429 / occasionally answers with a challenge page) */
      function getJSON(url, opts, tries) {
        tries = tries == null ? 1 : tries;
        return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, opts || {}))
          .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) { if ((r.status === 429 || r.status >= 500 || !j) && tries > 0) throw new Error('retry'); return j; }); })
          .catch(function (e) { if (tries > 0) return new Promise(function (res) { setTimeout(res, 1200); }).then(function () { return getJSON(url, opts, tries - 1); }); throw e; });
      }
      function isCart(c) { return !!c && typeof c.item_count === 'number'; }
      return getJSON(cartJs, null, 1).catch(function () { return null; })
        .then(function (c) { before = isCart(c) ? c : null; return getJSON(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartJs), null, 1).catch(function () { return null; }); })
        .then(function (cart) { return isCart(cart) ? cart : getJSON(cartJs, null, 1); })
        .then(function (cart) {
          var e = isCart(cart) && (cart.discount_codes || []).filter(function (d) { return up(d.code) === up(code); })[0];
          if (isCart(cart) && cart.item_count > 0 && !(e && e.applicable)) {
            return getJSON(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) }, 1)
              .then(function (c) { return isCart(c) ? c : getJSON(cartJs, null, 1); });
          }
          return cart;
        })
        .then(function (cart) {
          if (!isCart(cart)) throw new Error('no cart');
          /* Shopify lists any code on the cart (even unknown ones), so with items in the cart it must also be applicable
             (or have lowered the total) - unless another automatic discount is active, e.g. the Value Pack's free 2nd pack
             (an app/Function discount, whose discount_application.type is '' rather than 'automatic'), which codes can't combine with */
          var entry = (cart.discount_codes || []).filter(function (d) { return up(d.code) === up(code); })[0];
          var notCode = function (a) { return a && a.type !== 'discount_code' && up(a.title) !== up(code); };
          var autoOn = (cart.items || []).some(function (i) { return (i.line_level_discount_allocations || []).some(function (a) { return a.amount > 0 && notCode(a.discount_application); }); })
            || (cart.cart_level_discount_applications || []).some(function (a) { return notCode(a) && a.total_allocated_amount > 0; });
          var codeCut = (cart.cart_level_discount_applications || []).some(function (a) { return up(a.title) === up(code) && a.total_allocated_amount > 0; })
            || (cart.items || []).some(function (i) { return (i.line_level_discount_allocations || []).some(function (a) { return a.amount > 0 && a.discount_application && up(a.discount_application.title) === up(code); }); });
          var dropped = before && before.item_count === cart.item_count && cart.total_price < before.total_price;
          var onCart = up(cookieCode()) === up(code) || !!entry;
          var works = !cart.item_count || (entry && entry.applicable) || codeCut || dropped;
          if (onCart && !works && autoOn) {
            /* Free 2nd Value Pack (or another automatic discount) wins and codes can't combine: not "applied" */
            delete confirmed[up(code)];
            try { localStorage.removeItem(KEY); } catch (x) {}
            BW.cart = cart;
            var ce = new Error('combo'); ce.combo = true; throw ce;
          }
          var ok = onCart && works;
          if (!ok) {
            try { console.warn('[bw-sale] code not applied', { code: code, root: root, entry: entry, cookie: cookieCode(), items: cart.item_count, autoOn: autoOn }); } catch (x) {}
            throw new Error('not applied');
          }
          confirmed[up(code)] = true;
          try { localStorage.setItem(KEY, JSON.stringify({ code: up(code), t: Date.now() })); } catch (e) {}
          BW.cart = cart;
          document.dispatchEvent(new CustomEvent('bw:sale-applied', { detail: { code: code, cart: cart } }));
          return cart;
        });
    }
  };
  function setState(st) { $$('[data-bw-sale]').forEach(function (w) { w.setAttribute('data-state', st); var b = w.querySelector('[data-bw-apply]'); if (b) { b.disabled = st === 'busy'; b.setAttribute('aria-busy', st === 'busy' ? 'true' : 'false'); } }); S.rerender(); }
  function refreshDrawer() { try { if (BW.cartDrawer && BW.cartDrawer.refresh) BW.cartDrawer.refresh(); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bw-apply]'); if (!b) return;
    e.preventDefault();
    var w = b.closest('[data-bw-sale]'), code = w && w.getAttribute('data-code'); if (!code || w.getAttribute('data-state') === 'busy') return;
    setState('busy');
    S.apply(code).then(function () { S.animateNext = true; setState('applied'); refreshDrawer(); }, function (err) { setState(err && err.combo ? 'combo' : 'failed'); refreshDrawer(); });
  });
  /* Already applied (this session's cookie, or remembered from an earlier visit): show it, re-applying if the cookie is gone */
  function boot() {
    var code = BW.saleCode; if (!code) return;
    var mem = stored(), remembered = mem && up(mem.code) === up(code);
    /* Lex 6 Oct: never apply the code on page load. Only reflect a code the customer applied this session (Shopify cookie). */
    if (up(cookieCode()) === up(code) && remembered) { confirmed[up(code)] = true; S.rerender(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Cart changes: keep the remembered code on the cart once it has items (e.g. the code was applied with an empty cart) */
  var fixing = false;
  document.addEventListener('bw:cart-updated', function (e) {
    var cart = e.detail, code = BW.saleCode; if (!code || fixing || !cart || !cart.item_count) return;
    /* only carry a code the customer applied THIS session (cookie present) onto the cart - never a remembered one */
    var mem = stored(); if (!mem || up(mem.code) !== up(code) || cartHas(cart, code) || up(cookieCode()) !== up(code)) return;
    fixing = true;
    S.apply(code).then(function () { refreshDrawer(); }, function (err) { if (err && err.combo) setState('combo'); }).then(function () { fixing = false; });
  });
})();

/* Auto-add free 2nd Value Pack when BOGO is live.
   - If the cart has exactly 1 Value Pack (and BOGO hasn't ended), bump to qty 2 so Shopify's automatic discount
     makes the 2nd free. On an initial add that lands on an odd qty (e.g. 3), bump to the next even.
   - If the customer deliberately reduces from 2 (or any even) to 1 (odd), remember via sessionStorage and stop
     auto-bumping for this tab; the existing "Claim your 2nd FREE" card shows instead.
   - Clears the opt-out when the Value Pack is removed from the cart. */
(function () {
  var BW = (window.BW = window.BW || {});
  var OPT_KEY = 'bwBogoOptOut';
  var DEFAULT_HANDLE = 'teeth-whitening-kit-value-pack';
  var busy = false;
  var lastVpQty = -1;
  var skipEnsure = false;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || (BW.routes && BW.routes.root) || '/'; }
  function drawer() { return document.querySelector('[data-bw-cart-drawer]'); }
  function handle() {
    var el = drawer();
    return ((el && el.getAttribute('data-bw-bogo-handle')) || DEFAULT_HANDLE).trim();
  }
  function live() {
    var el = drawer();
    if (!el || el.getAttribute('data-bw-bogo-live') !== 'true') return false;
    var end = parseInt(el.getAttribute('data-bw-bogo-end'), 10) || 0;
    if (end > 0 && (Date.now() / 1000) >= end) return false;
    return true;
  }
  function optedOut() { try { return sessionStorage.getItem(OPT_KEY) === '1'; } catch (e) { return false; } }
  function setOptOut(on) {
    try { if (on) sessionStorage.setItem(OPT_KEY, '1'); else sessionStorage.removeItem(OPT_KEY); } catch (e) {}
  }
  function isVp(item) {
    var h = handle();
    if (!item) return false;
    if (item.handle === h) return true;
    var url = item.url || '';
    return url.indexOf('/products/' + h) > -1 || url.indexOf('/products/' + h + '?') > -1;
  }
  function vpItems(cart) { return ((cart && cart.items) || []).filter(isVp); }
  function vpQty(cart) { return vpItems(cart).reduce(function (n, i) { return n + (i.quantity || 0); }, 0); }

  function rerenderCartPage() {
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    if (!items || !items.getAttribute('data-id')) return Promise.resolve();
    var ids = [items.getAttribute('data-id')];
    if (foot && foot.getAttribute('data-id')) ids.push(foot.getAttribute('data-id'));
    return fetch(root() + 'cart?sections=' + ids.join(','))
      .then(function (r) { if (!r.ok) throw new Error('render'); return r.json(); })
      .then(function (d) {
        [[items, ids[0]], [foot, ids[1]]].forEach(function (p) {
          if (!p[0] || !p[1] || !d[p[1]]) return;
          var doc = new DOMParser().parseFromString(d[p[1]], 'text/html');
          var src = doc.querySelector('.js-contents'), dst = p[0].querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        if (BW.bogoCheck) BW.bogoCheck(document);
      })
      .catch(function () {});
  }

  function applyBump(item, newQty) {
    busy = true;
    skipEnsure = true;
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: newQty, sections: ['bw-cart-drawer'] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not update cart');
        return d;
      });
    }).then(function (cart) {
      var cd = BW.cartDrawer;
      if (cd && cd.enabled && cd.enabled()) {
        if (cart.sections && cart.sections['bw-cart-drawer'] && cd.swap) cd.swap(cart.sections['bw-cart-drawer']);
        else if (cd.refresh) cd.refresh();
      }
      return rerenderCartPage().then(function () {
        return (BW.refreshCart ? BW.refreshCart() : Promise.resolve(cart));
      }).then(function (c) {
        busy = false;
        skipEnsure = false;
        lastVpQty = vpQty(c || cart);
        if (cd && cd.announce) cd.announce('2nd Value Pack added free');
        return c || cart;
      });
    }).catch(function (err) {
      busy = false;
      skipEnsure = false;
      return null;
    });
  }

  BW.bogoEnsure = function (opts) {
    opts = opts || {};
    if (busy || !live() || optedOut()) return Promise.resolve(null);
    var start = BW.cart ? Promise.resolve(BW.cart) : fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return start.then(function (cart) {
      if (!cart || busy || !live() || optedOut()) return null;
      var qty = vpQty(cart);
      var target = null;
      if (qty === 1) target = 2;
      else if (opts.initialAdd && qty > 0 && qty % 2 === 1) target = qty + 1;
      if (!target || target === qty) return null;
      var items = vpItems(cart);
      if (!items.length) return null;
      var item = items[0];
      var newQty = item.quantity + (target - qty);
      if (newQty < 1) return null;
      return applyBump(item, newQty);
    }).catch(function () { return null; });
  };

  /* After every add (product page, recs, claim): bump odd Value Pack qty while BOGO is live. */
  if (BW.addToCart && !BW._bwBogoAddWrapped) {
    BW._bwBogoAddWrapped = true;
    var origAdd = BW.addToCart;
    BW.addToCart = function (items) {
      return origAdd.apply(this, arguments).then(function (data) {
        return BW.bogoEnsure({ initialAdd: true }).then(function () { return data; });
      });
    };
  }

  document.addEventListener('bw:cart-updated', function (e) {
    var cart = e.detail;
    if (!cart) return;
    var qty = vpQty(cart);
    if (qty <= 0) setOptOut(false);
    else if (lastVpQty >= 2 && qty > 0 && qty % 2 === 1 && qty < lastVpQty) setOptOut(true);
    lastVpQty = qty;
    if (skipEnsure || busy || !live() || optedOut()) return;
    if (qty === 1) BW.bogoEnsure();
  });

  /* Dawn /cart page quantity changes publish PUB_SUB_EVENTS.cartUpdate; sync BW.cart so the listener above can run. */
  function hookPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
    if (BW._bwBogoPubSub) return;
    BW._bwBogoPubSub = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === 'bw-bogo') return;
      if (BW.refreshCart) BW.refreshCart();
    });
  }

  function start() {
    hookPubSub();
    if (BW.refreshCart) BW.refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* 3 Month kit -> Value Pack upgrade card + BOGO end time (snippets/bw-upgrade-card, snippets/bw-bogo-state).
   - BW.bogoCheck: elements with data-bw-bogo-end="<unix seconds>" are re-checked in the browser (pages/sections can be
     cached after Liquid rendered them): once that fixed time has passed, [data-bw-bogo-only] is hidden and the upgrade
     card switches to its plain copy (data-plain-title). No countdowns.
   - Upgrade button: swaps the 3 Month line(s) for the Value Pack at the same quantity in ONE /cart/update.js call
     (line keys -> 0, Value Pack variant -> qty), checks the result, falls back to add.js + change.js, restores the
     3 Month kit if the Value Pack couldn't be added, then re-renders the drawer / cart page sections. The automatic
     Buy X get Y discount and the "2nd Value Pack FREE" cards take over from there.
   - Claim button (/cart page): adds a 2nd Value Pack (the BOGO discount makes it free) and re-renders. */
(function () {
  var BW = (window.BW = window.BW || {});
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function post(path, body) {
    return fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'Cart update failed'); e.status = r.status; throw e; } return d; }); });
  }
  function getCart() { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function qtyOf(cart, vid) { return (cart.items || []).reduce(function (n, i) { return n + (String(i.variant_id) === String(vid) ? i.quantity : 0); }, 0); }

  BW.bogoCheck = function (ctx) {
    var now = Date.now() / 1000;
    $$('[data-bw-bogo-end]', ctx || document).forEach(function (el) {
      var end = parseInt(el.getAttribute('data-bw-bogo-end'), 10);
      if (!end || now < end) return;
      if (el.hasAttribute('data-bw-upgrade')) {
        el.classList.add('is-plain');
        var t = el.querySelector('[data-bw-upgrade-title]'), pt = el.getAttribute('data-plain-title');
        if (t && pt) t.textContent = pt;
        $$('[data-bw-bogo-only]', el).forEach(function (x) { x.hidden = true; });
      }
      if (el.hasAttribute('data-bw-bogo-only')) el.hidden = true;
    });
  };

  /* Re-render after a swap: drawer via its own refresh; /cart page via the Section Rendering API (same .js-contents Dawn swaps) */
  function rerender(card) {
    var jobs = [];
    var cd = BW.cartDrawer;
    if (cd && cd.enabled && cd.enabled() && cd.refresh) jobs.push(cd.refresh());
    var items = document.getElementById('main-cart-items'), foot = document.getElementById('main-cart-footer');
    if (items && items.getAttribute('data-id')) {
      var ids = [items.getAttribute('data-id')]; if (foot && foot.getAttribute('data-id')) ids.push(foot.getAttribute('data-id'));
      jobs.push(fetch(root() + 'cart?sections=' + ids.join(','))
        .then(function (r) { if (!r.ok) throw new Error('render'); return r.json(); })
        .then(function (d) {
          [[items, ids[0]], [foot, ids[1]]].forEach(function (p) {
            if (!p[0] || !p[1] || !d[p[1]]) return;
            var doc = new DOMParser().parseFromString(d[p[1]], 'text/html');
            var src = doc.querySelector('.js-contents'), dst = p[0].querySelector('.js-contents');
            if (src && dst) dst.innerHTML = src.innerHTML;
          });
          BW.bogoCheck(document);
        })
        .catch(function () { window.location.reload(); }));
    }
    return Promise.all(jobs).then(function () { if (BW.refreshCart) BW.refreshCart(); });
  }

  function fail(card, btn, msg) {
    if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    var e = card && card.querySelector('[data-bw-upgrade-err]');
    if (e) { e.textContent = msg; e.hidden = false; } else if (BW.toast) BW.toast(msg);
  }

  BW.upgradeSwap = function (card) {
    var keys = (card.getAttribute('data-keys') || '').split(',').filter(Boolean);
    var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
    var to = card.getAttribute('data-to'), from = card.getAttribute('data-from');
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    updates[to] = qty;
    return post('cart/update.js', { updates: updates })
      .catch(function () { return getCart(); })
      .then(function (cart) {
        var hasTo = qtyOf(cart, to) >= qty, fromLeft = qtyOf(cart, from);
        if (hasTo && !fromLeft) return cart;
        /* fallback: two steps (add the Value Pack first, so a failed add never empties the 3 Month line) */
        var step = hasTo ? Promise.resolve() : post('cart/add.js', { items: [{ id: parseInt(to, 10), quantity: qty - qtyOf(cart, to) }] });
        return step.then(function () {
          return fromLeft ? post('cart/update.js', { updates: (function () { var u = {}; u[from] = 0; return u; })() }) : getCart();
        }).catch(function (err) {
          /* Value Pack couldn't be added: put the 3 Month kit back if the first call removed it, and report */
          return getCart().then(function (c) {
            var restore = qtyOf(c, to) ? Promise.resolve() : (qtyOf(c, from) < qty ? post('cart/add.js', { items: [{ id: parseInt(from, 10), quantity: qty - qtyOf(c, from) }] }) : Promise.resolve());
            return restore.catch(function () {}).then(function () { throw err; });
          });
        });
      })
      .then(function () { return getCart(); })
      .then(function (cart) {
        if (qtyOf(cart, to) < qty) throw new Error('not added');
        return cart;
      });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bw-upgrade-btn], [data-bw-claim-btn]');
    if (!btn || btn.disabled) return;
    var card = btn.closest('[data-bw-upgrade], [data-bw-claim]'); if (!card) return;
    e.preventDefault();
    btn.disabled = true; btn.classList.add('is-loading');
    var err = card.querySelector('[data-bw-upgrade-err]'); if (err) err.hidden = true;
    var body = card.closest('[data-bw-cart-body]'); if (body) body.classList.add('is-busy');
    var isClaim = btn.hasAttribute('data-bw-claim-btn');
    var job = isClaim
      ? post('cart/add.js', { items: [{ id: parseInt(card.getAttribute('data-to'), 10), quantity: 1 }] })
      : BW.upgradeSwap(card);
    job.then(function () {
      return rerender(card).then(function () {
        var cd = BW.cartDrawer;
        if (cd && cd.announce) cd.announce(isClaim ? '2nd Value Pack added free' : 'Upgraded to the ' + (card.getAttribute('data-to-title') || 'Value Pack'));
      });
    }).catch(function (x) {
      if (body) body.classList.remove('is-busy');
      var sold = x && x.status === 422;
      fail(card, btn, sold ? 'Sorry, the Value Pack is unavailable right now. Your cart hasn\u2019t changed.' : 'Sorry, we couldn\u2019t update your cart. Please try again.');
      rerender(card);
    });
  });

  /* Re-check the BOGO end time whenever the drawer or the /cart items re-render */
  function hook() {
    var cd = BW.cartDrawer;
    if (cd && cd.bindBody && !cd._bwBogoWrapped) {
      var orig = cd.bindBody; cd._bwBogoWrapped = true;
      cd.bindBody = function () { var r = orig.apply(this, arguments); BW.bogoCheck(cd.el || document); return r; };
    }
  }
  hook();
  function start() {
    hook(); BW.bogoCheck(document);
    var items = document.getElementById('main-cart-items');
    if (items && 'MutationObserver' in window) new MutationObserver(function () { BW.bogoCheck(items); }).observe(items, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ---------- "How whitening works" video (gallery tile + How does it work? section) ----------
   Hismile-style muted looping explainer. The MP4 isn't requested on page load: its data-src is attached once the
   video is within ~300px of the viewport (observers start at DOMContentLoaded, not window load, so slow
   third-party scripts can't hold it back). It plays only while visible.
   Reliability: muted set as attribute + property before loading; if play() is refused (iPhone Low Power Mode,
   data saver), the video errors, or it hasn't started ~4s after becoming visible, a play button shows over the
   poster and plays on tap. prefers-reduced-motion: no autoplay, play button instead. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nearIO, playIO, started = false;
  function btn(v) { return v.parentElement && v.parentElement.querySelector('[data-bw-hm-play]'); }
  function showBtn(v, on) { var b = btn(v); if (b) b.hidden = !on; }
  function attach(v) {
    if (v._bwLoaded) return; v._bwLoaded = true;
    if (!v.poster && v.getAttribute('data-poster')) v.poster = v.getAttribute('data-poster');
    var so = v.querySelector('source[data-src]'), src = so && so.getAttribute('data-src');
    if (so) so.parentNode.removeChild(so);
    if (src) { v.preload = 'auto'; v.src = src; v.load(); }
  }
  function tryPlay(v) {
    attach(v);
    if (reduce || v._bwUser === false) { showBtn(v, true); return; }
    var p; try { p = v.play(); } catch (err) { showBtn(v, true); return; }
    if (p && p.catch) p.catch(function (err) { if (!err || err.name !== 'AbortError') showBtn(v, true); });
    clearTimeout(v._bwWd);
    v._bwWd = setTimeout(function () { if (v._bwVisible && (v.paused || v.readyState < 3)) showBtn(v, true); }, 4000);
  }
  function prep(v) {
    if (v._bwHm) return; v._bwHm = true;
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.addEventListener('playing', function () { showBtn(v, false); });
    v.addEventListener('error', function () { showBtn(v, true); });
    var b = btn(v);
    if (b) b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      v._bwUser = true; attach(v); v.muted = true;
      var p = v.play(); if (p && p.then) p.then(function () { showBtn(v, false); }).catch(function () { v.controls = true; showBtn(v, false); });
    });
    if (reduce) { attach(v); showBtn(v, true); return; }
    if (!('IntersectionObserver' in window)) { v._bwVisible = true; tryPlay(v); return; }
    nearIO.observe(v); playIO.observe(v);
  }
  function scan(root) {
    if (!started) return;
    Array.prototype.forEach.call((root || document).querySelectorAll('video[data-bw-hm]'), prep);
  }
  function start() {
    if (started) return; started = true;
    if ('IntersectionObserver' in window) {
      nearIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { attach(e.target); nearIO.unobserve(e.target); } }); }, { rootMargin: '300px' });
      playIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target; v._bwVisible = e.isIntersecting;
          if (e.isIntersecting) { if (v.paused && !reduce && v._bwUser !== false) tryPlay(v); }
          else if (!v.paused && !v._bwUser) v.pause();
        });
      }, { threshold: [0, 0.05] });
    }
    scan(document);
    document.addEventListener('visibilitychange', function () {
      Array.prototype.forEach.call(document.querySelectorAll('video[data-bw-hm]'), function (v) {
        if (document.hidden) { if (!v.paused) v.pause(); }
        else if (v._bwVisible && v.paused && !reduce) tryPlay(v);
      });
    });
  }
  window.BWHowMedia = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
